import { render, staticRenderFns } from "./tongji.vue?vue&type=template&id=14c7e9e4&scoped=true&"
import script from "./tongji.vue?vue&type=script&lang=js&"
export * from "./tongji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c7e9e4",
  null
  
)

export default component.exports